import { RouteEnum } from '@enum/route.enum';

export const subPageRouteMenu = {
  [RouteEnum.ConsumerView.name]: [RouteEnum.Consumers.name],

  [RouteEnum.IntegrationView.name]: [RouteEnum.Integrations.name],

  [RouteEnum.NewSequences.name]: [RouteEnum.Sequences.name],
};
